import { canCallApp, user, getFlow } from '../utils.js';
import * as $ from 'jquery';
import * as bi from '../tracking/bi.js';
import { onLoad } from './onLoad';

// Data models tracking (BI & Zendesk)
import {
    MKTShareClosetBIModel,
    MKTShareCollectionBIModel,
    MKTShareProductBIModel
} from '../BI/models';

onLoad(() => {

    const SHARE = {
        COLLECTION: 'share-collection',
        PRODUCT_SHEET: 'share-product-',
        PROFILE: 'share-profile'
    }

    document.addEventListener('click', (e) => {

        if (e.target.matches('[data-share], [data-share] span')) {

            const button = e.target.closest('[data-share]');
            const scriptId = button.dataset.share;
            const data = document.querySelector(scriptId);
            let dataParsed = {};

            if (data) {
                try { dataParsed = JSON.parse(data.innerHTML); }
                catch(e) { console.log(error); }
            }
          
            if (canCallApp('share')) {
                Trendier.share(data.innerHTML);
            } else if (navigator.share) {
                navigator.share({
                    title: dataParsed.title,
                    text: dataParsed.text,
                    url: dataParsed.url
                }).catch(err => {
                    if (err.name === 'AbortError') return; // El usuario canceló el diálogo de compartir
                    throw err;
                });
            } else if(canCallApp('shareProduct') && Object.prototype.hasOwnProperty.call(data, 'productId')) { 
                //Funcion antigua que requiere llamar a la api para obtener la info del producto xP
                Trendier.shareProduct(data.productId);
            
            } else {
                
                $(button).popover('toggle');
                $(button)
                    .off('shown.bs.popover')
                    .on('shown.bs.popover', (e) => {
                        const popoverId = button.getAttribute('aria-describedby');
                        const linksToShare = document.querySelectorAll(`#${popoverId} .share-box > a`);
                        let flow = getFlow();
                           
                        linksToShare.forEach(link => {
                          
                            let biModel = null;
                            const biParams = link.dataset.biParams;
                            let biParamsParsed = {};
                            
                            try { biParamsParsed = JSON.parse(biParams); }
                            catch(e) { console.log(e.error); }

                            if (Object.keys(biParamsParsed).length > 0 && flow) {
                                biParamsParsed = { ...biParamsParsed, flow }
                            }

                            if ( scriptId.includes( SHARE.COLLECTION )) {
                                const { flow, collection_name, channel } = biParamsParsed;
                                biModel = new MKTShareCollectionBIModel(user?.id, flow, collection_name, channel);

                            } else if ( scriptId.includes( SHARE.PRODUCT_SHEET )) {
                                const { product_id, channel, flow } = biParamsParsed;
                                biModel = new MKTShareProductBIModel(user?.id, product_id, channel, flow);

                            } else if ( scriptId.includes( SHARE.PROFILE )) {
                                const { flow, closet_owner_id, channel } = biParamsParsed;
                                biModel = new MKTShareClosetBIModel(user?.id, flow, closet_owner_id, channel);
                            } 

                            link.addEventListener('click', (e) => bi.track(biModel));
                        })

                    })
            }
        }
    });    
});